import { Neuron, NeuronProvider as Provider } from "@sphtech/neuron";
import { ReactElement, ReactNode } from "react";

type Props = {
  children: ReactNode;
};

Neuron.default.setConfig({});

export default function NeuronProvider({ children }: Props): ReactElement {
  return (
    <Provider
      config={{
        sessionApiUrl: import.meta.env.VITE_NEURON_API_URL,
        sessionApiToken: import.meta.env.VITE_NEURON_API_TOKEN,
        segmentsApiUrl: import.meta.env.VITE_SEGMENTO_API_URL,
        extends: [
          "https://neuron.platform.sphdigital.com.sg/config/default.config.json",
        ],
      }}
    >
      {children}
    </Provider>
  );
}
